<template>
	<div id="evaluate">
		<div id="content">
			<p class="title">评价内容</p>
			<textarea class="content"  placeholder="请输入评价内容" v-model="content"></textarea>
			<!--<img src="../../../static/img/tel.png"/>-->
      <div id="fiveStars">
        <div>到场时间：<img v-for="(star,index) in stars.list" :src="star.src" @click="rating(index, stars)"  /></div>
        <div>专业水平：<img v-for="(star,index) in stars1.list" :src="star.src" @click="ratingLevel(index, stars1)"  /></div>
        <div>服务态度：<img v-for="(star,index) in stars2.list" :src="star.src" @click="ratingAttitude(index, stars2)"  /></div>
      </div>
			<!--<FiveStars @rating="rating" @ratingLevel="ratingLevel" @ratingAttitude="ratingAttitude" :starsAll="starsAll"></FiveStars>-->
		</div>
		<input type="button"  id="btn" value="提交" @click="back"/>
	</div>
</template>

<script>
import wx from 'weixin-js-sdk';
	import FiveStars from './fiveStars.vue'
	//黑星星的路径
	const starOff ='../../../static/img/wjx-old.png';
	//亮星星的路径
	const starOn='../../../static/img/wjx-new.png';
	export default{
		components:{
			FiveStars:FiveStars
		},
		data(){
			return {
					stars: {
						list: [
							{src: starOff, active: false},
							{src: starOff, active: false},
							{src: starOff, active: false},
							{src: starOff, active: false},
							{src: starOff, active: false},
						],
						starNum:0
							},
					stars1:{
						list: [
							{src:starOff,active:false},
							{src:starOff,active:false},
							{src:starOff,active:false},
							{src:starOff,active:false},
							{src:starOff,active:false},
						],
						starNum:0
							},
					stars2:{
						list: [
							{src:starOff,active:false},
							{src:starOff,active:false},
							{src:starOff,active:false},
							{src:starOff,active:false},
							{src:starOff,active:false},
						],
						starNum:0 //点击星星的次数
							},
				arr:[],//点击的星星的index
				content:''//评价内容
			}
		},
		methods:{
			rating(index, stars){
				let total = stars.list.length;//星星总数
				let idx = index + 1//代表应该显示的星星的数量
				if(stars.starNum ==0){ //只点了一个星星
					stars.starNum =idx
					for(var i=0;i<idx;i++){
					stars.list[i].src=starOn;
					stars.list[i].active=true;
					}
				}else{
          //如果再次点击当前选中的星级-仅取消掉当前星级，保留之前的。
					if(idx == stars.starNum){
						for(var i=idx;i<total;i++){
							stars.list[i].src=starOff;
							stars.list[i].active=false;
						}
					}
          //如果小于当前最高星级，则直接保留当前星级
					if(idx <stars.starNum){
						for(var i=idx;i<stars.starNum;i++){
							stars.list[i].src=starOff;
							stars.list[i].active=false;
						}
					}
          //如果大于当前星级，则直接选到该星级
					if(idx > stars.starNum){
						for(var i=0;i<idx;i++){
							stars.list[i].src=starOn;
							stars.list[i].active=true;
						}
					}
					let count =0;//当前几颗星
					for(var i=0;i<total;i++){
						if(stars.list[i].active){
							count++;
						}
					}
					stars.starNum =count;
          console.log(stars.starNum)
        }
			},
      //专业水平
      ratingLevel(index, stars){
        let total = stars.list.length;//星星总数
        let idx = index + 1//代表应该显示的星星的数量
        if(stars.starNum ==0){  //只点了一个星星
          stars.starNum =idx
          for(var i=0;i<idx;i++){
            stars.list[i].src=starOn;
            stars.list[i].active=true;
          }
        }else{
          //如果再次点击当前选中的星级-仅取消掉当前星级，保留之前的。
          if(idx == stars.starNum){
            for(var i=idx;i<total;i++){
              stars.list[i].src=starOff;
              stars.list[i].active=false;
            }
          }
          //如果小于当前最高星级，则直接保留当前星级
          if(idx <stars.starNum){
            for(var i=idx;i<stars.starNum;i++){
              stars.list[i].src=starOff;
              stars.list[i].active=false;
            }
          }
          //如果大于当前星级，则直接选到该星级
          if(idx > stars.starNum){
            for(var i=0;i<idx;i++){
              stars.list[i].src=starOn;
              stars.list[i].active=true;
            }
          }
          let count =0;//当前几颗星
          for(var i=0;i<total;i++){
            if(stars.list[i].active){
              count++;
            }
          }
          stars.starNum =count;
          console.log(stars.starNum)
        }
      },
      //服务态度
      ratingAttitude(index, stars){
        let total = stars.list.length;//星星总数
        let idx = index + 1//代表应该显示的星星的数量
        if(stars.starNum ==0){  //只点了一个星星
          stars.starNum =idx
          for(var i=0;i<idx;i++){
            stars.list[i].src=starOn;
            stars.list[i].active=true;
          }
        }else{
          //如果再次点击当前选中的星级-仅取消掉当前星级，保留之前的。
          if(idx == stars.starNum){
            for(var i=idx;i<total;i++){
              stars.list[i].src=starOff;
              stars.list[i].active=false;
            }
          }
          //如果小于当前最高星级，则直接保留当前星级
          if(idx <stars.starNum){
            for(var i=idx;i<stars.starNum;i++){
              stars.list[i].src=starOff;
              stars.list[i].active=false;
            }
          }
          //如果大于当前星级，则直接选到该星级
          if(idx > stars.starNum){
            for(var i=0;i<idx;i++){
              stars.list[i].src=starOn;
              stars.list[i].active=true;
            }
          }
          let count =0;//当前几颗星
          for(var i=0;i<total;i++){
            if(stars.list[i].active){
              count++;
            }
          }
          stars.starNum =count;
          console.log(stars.starNum)
        }
      },
      //提交评价内容 返回上一页
			back(){
//				console.log(this.content)
//				console.log(this.arr)
        let that = this;
        if(!that.content){
          alert('评价内容不能为空！')
        }else if(!that.$route.params.id){
          alert('请重新进入该页面！')
        }else{
          that.postRequest('wo/repareEvaluation',{
            maintainId: that.$route.params.id,
            content: that.content,
            arriveDate: that.stars.starNum,
            majorLevel: that.stars1.starNum,
            serviceAttitude: that.stars2.starNum,
          },function (data) {
            console.log(data)
            alert('评价成功')
            that.$router.push({
              name:'repairDetails',
              params:{
                id: that.$route.params.id
              }
            })
          })
        }
			}
		}
	}
</script>

<style scoped lang="less">
	#evaluate{
		#content{
			padding:0px 40px;
			position:relative;
			.title{
				font-size: 32px;
				padding: 30px 0px;
				box-sizing: border-box;
				line-height: 40px;
			};
			.content{
				width:100%;
				resize:none;
        font-size: 30px;
				height:180px;
				padding:20px 0 0 20px;
				box-sizing: border-box;
			};
      #fiveStars{
        div{
          font-size:30px;
          text-align: left;
          line-height: 60px;
          img{
            width:40px;
            margin-right: 10px;
            vertical-align: middle;
          }
        };
      }
			p{
				font-size:30px;
				text-align: left;
				line-height: 60px;
				img{
					width:40px;
					margin-right: 10px;
					vertical-align: middle;
				}
			};
		}
		input{
			width:90%;
			height:90px;
			font-size: 30px;
			background-color: #F7B632;
			border-radius: 90px;
			color:#fff;
			margin:100px 0 30px 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/son/evaluate.vue